module.exports = __webpack_public_path__ + "img/menottis.ac5a13be.jpg";